import { SyntheticEvent, useEffect, MouseEvent, ClipboardEvent } from 'react';
import { SxProps } from '@mui/material';

interface IUsePreventCopyReturn {
  handlePreventCopy: (event: ClipboardEvent) => void;
  handlePreventContextMenu: (event: MouseEvent) => void;
  handlePreventSelectStart: (event: SyntheticEvent) => void;
  preventCopyStyles: SxProps;
}

const usePreventCopy = (): IUsePreventCopyReturn => {
  const handlePreventCopy = (event: ClipboardEvent) => {
    event.preventDefault();
  };

  const handlePreventContextMenu = (event: MouseEvent) => {
    event.preventDefault();
  };

  const handlePreventSelectStart = (event: SyntheticEvent) => {
    event.preventDefault();
  };

  const preventCopyStyles = { userSelect: 'none', cursor: 'default' };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'c') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return {
    handlePreventCopy,
    handlePreventContextMenu,
    handlePreventSelectStart,
    preventCopyStyles,
  };
};

export default usePreventCopy;
